<template>
  <img
    :class="[effect, { loaded: loaded }]"
    :src="src"
    :alt="alt"
    @load="handleLoaded"
  />
</template>
<script setup lang="ts">
interface Props {
  src: string;
  alt: string;
  effect: 'fade-in' | 'scale-in' | 'scale-and-fade' | 'none';
}
defineProps({
  src: null,
  alt: null,
  effect: { default: 'fade-in' }
});
const emit = defineEmits(["load"]);
const loaded = ref(false);
const handleLoaded = () => {
  loaded.value = true;
  emit('load');
};
</script>
<style lang="scss" scoped>
img {
  transform-origin: 50% 50%;
  &.fade-in {
    transition: opacity 300ms $ease-in-quad 50ms;
    opacity: 0;
    &.loaded {
      opacity: 1;
    }
  }
  &.scale-in {
    transform: scale(0);
    transition: transform 300ms $ease-out-quad;
    &.loaded {
      transform: scale(1);
    }
  }
  &.scale-and-fade {
    transform: scale(0);
    transition: opacity 300ms $ease-in-quad, transform 300ms $ease-out-quad;
    opacity: 0;
    &.loaded {
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>
